import { getTestData } from '../../testData/testMapper';

export async function getMatchData(match_name: string) {
    // do something else if localhost (local testing)
    if (window.location.host.includes('localhost')) {
        console.log('localhost detected');
        return new Response(JSON.stringify(getTestData(match_name)));
    }
    const response = await fetch('https://bct-scoreboard-v2.taegener.eu/web/access/get_match_data.php', {
        mode: 'cors',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({ match_kind: match_name }),
    });
    if (!response.ok) {
        throw new Error('Error getting match data. HTTP status: ' + response.status);
    }
    console.info('[MatchController.ts] Match data retrieved successfully.');
    return response;
}
